import { render, staticRenderFns } from "./previewAds.vue?vue&type=template&id=db59e9aa&scoped=true"
import script from "./previewAds.vue?vue&type=script&lang=js"
export * from "./previewAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db59e9aa",
  null
  
)

export default component.exports